import React from "react";

import { Check } from "icons";

export const ASSOCIATE_DATA_SOURCE_COLUMN = [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "30%",
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "40%",
  },
  {
    title: "Type",
    key: "db_name",
    dataIndex: "db_name",
    width: "20%",
    render: () => "RDBMS",
  },
  {
    title: "",
    key: "checked",
    dataIndex: "checked",
    render: text =>
      text && <Check size={15} style={{ color: "rgb(34, 118, 251)" }} />,
    width: "10%",
  },
];

export const ASSOCIATE_DATA_SOURCE_ROW = [
  { id: 1, name: "Acuity", description: "acuity-sql" },
  {
    id: 2,
    name: "Cerner",
    description: "cerner-CSV",
  },
  {
    id: 3,
    name: "CVO Aperture",
    description: "CVO Aperture",
  },
  { id: 4, name: "IDX", description: "idx" },
  {
    id: 5,
    name: "Morrisey",
    description: "Morrisey",
  },
];
